import { useTranslation } from "react-i18next";
import { Avatar, Form, Space, TreeSelect } from "antd";
import { useEffect, useState } from "react";

type UniversityTreeSelectProps = {
  data: [];
  onChange: (value: any) => void;
};

interface University {
  id: number;
  uuid: string;
  name: string;
  canManage: boolean;
  logo?: string | null;
  children?: University[];
  isDaiHoc: boolean;
  universityId: number;
}

const UniversityTreeSelect = ({ data, onChange }: UniversityTreeSelectProps) => {
  const { t } = useTranslation();
  const [dataSource, setDataSource] = useState<University[]>([]);

  const processChildren = (data: University[]): University[] => {
    return data?.map((item) => {
      const newItem = { ...item };
      if (newItem.children && newItem.children.length === 0) {
        delete newItem.children;
      } else if (newItem.children) {
        newItem.children = processChildren(newItem.children);
      }
      return newItem;
    });
  };

  const generateTreeData = (nodes: University[]): any[] => {
    return nodes?.map((node) => {
      const { id, name, logo, children } = node;

      return {
        title: (
          <Space>
            <Avatar shape="square" size="small" src={logo} />
            {name}
          </Space>
        ),
        value: id,
        dataRef: node,
        children:
          children && children.length > 0
            ? generateTreeData(children)
            : undefined,
      };
    });
  };

  const findNodeById = (
    nodes: University[],
    id: number
  ): University | undefined => {
    for (const node of nodes) {
      if (node.id === id) {
        return node;
      }
      if (node.children && node.children.length > 0) {
        const found = findNodeById(node.children, id);
        if (found) {
          return found;
        }
      }
    }
    return undefined;
  };

  useEffect(() => {
    const formattedData = processChildren(
      data?.map((item: any) => ({
        ...item,
        key: item.id,
        children: item.children?.map((child: any) => ({
          ...child,
          key: child.id,
        })),
      }))
    );
    setDataSource(formattedData);
  }, [data]);

  return (
    <TreeSelect
      treeData={generateTreeData(dataSource)}
      placeholder={t("Chọn cơ sở đào tạo", "Chọn cơ sở đào tạo")}
      treeDefaultExpandAll
      showSearch
      allowClear
      onChange={(value) => {
        const selectedNode = findNodeById(dataSource, value);
        onChange(selectedNode || null);
      }}
      filterTreeNode={(input, treeNode) =>
        (treeNode.dataRef?.name || "")
          .toLowerCase()
          .includes(input.toLowerCase())
      }
      notFoundContent={
        <span style={{ textAlign: "center" }}>
          <p>
            <img
              className="image-empty-data"
              src="/images/empty-img-gray.png"
              alt="empty-img"
            ></img>
          </p>
          <p className="nodata-text">{t("Không tìm thấy", "Không tìm thấy")}</p>
        </span>
      }
    />
  );
};

export default UniversityTreeSelect;
